<template>
    <div class="row">
        <div class="col-auto">
            <input-group icon="far fa-hourglass">
                <input type="number" class="form-control" v-model="time" :disabled="disabled || !unit" />
            </input-group>
        </div>
        <div class="col-auto">
            <input-group icon="far fa-clock">
                <v-select class='form-control'
                    v-if="options.length != 0"
                    v-model="unit"

                    :options="options"
                    :clearable="false"
                    close-on-select
                          
                    :disabled="disabled"
                >
                    <div slot='no-options' />
                </v-select>
            </input-group>
        </div>
        <div class="col-auto" v-if="showBeforeAfter">
            <input type="radio" :id="afterElementId" value="after" v-model="beforeAfter" :disabled="disabled">
            <label :for="afterElementId">{{resource('JourneyBuilder_FilterSettings_Offset_After')}}</label>
            <br />
            <input type="radio" :id="beforeElementId" value="before" v-model="beforeAfter" :disabled="disabled">
            <label :for="beforeElementId">{{resource('JourneyBuilder_FilterSettings_Offset_Before')}}</label>
        </div>
    </div>
</template>

<script>

import {timeUnit, toSeconds, fromSeconds} from '../../Util/time';

import InputGroup from './InputGroup.vue';
import VSelect from 'vue-select';
import resources from '../../Util/Mixins/resources';
import guid from '../../Util/Mixins/guid';

export default {
    name: 'time-period',
    mixins: [resources, guid],
    components: {
        VSelect,
        InputGroup
    },
    created() {
        const vm = this;

        //Ensure our newValue contains the required properties, and is reactive
        vm.newValue = {};
        vm.$set(vm.newValue, 'unit', !!(vm.value && vm.value.unit) ? vm.value.unit : '');
        vm.$set(vm.newValue, 'seconds', !!(vm.value && vm.value.seconds) ? vm.value.seconds : 0);

        vm.beforeAfter = vm.newValue.seconds < 0 ? 'before' : 'after';
    },
    computed: {
        options() {
            const keys = Object.keys(timeUnit);
            const options = [];

            keys.forEach((key) => {
                options.push({ label: key, value: timeUnit[key] })
            });
            
            return options.reverse();
        },
        time: {
            get: function() {
                return fromSeconds(this.newValue.seconds, this.newValue.unit);
            },
            set: function(value) {
                this.newValue.seconds = toSeconds(value, this.unit.value);
            }
        },
        unit: {
            get: function() {
                const vm = this;
                const option = vm.options.find((option) => option.value === vm.newValue.unit);
                
                return option;
            },
            set: function(unit) {
                this.newValue.unit = unit ? unit.value : null;
                
                //Ensure our number is rounded on switch to another unit
                if(this.newValue.unit){
                    this.time = Math.round(fromSeconds(this.newValue.seconds, this.newValue.unit));
                }
            }
        }
    },
    watch: {
        newValue: {
            handler: function(value) {
                if(value.seconds < 0)
                    this.beforeAfter = 'before'
                else
                    this.beforeAfter = 'after'

                this.$emit('input', value);
            },
            deep: true
        },
        beforeAfter(value) {
            if(this.newValue.unit) {
                if(value === 'before') {
                    this.time = -Math.abs(this.time);
                } else {
                    this.time = Math.abs(this.time);
                }
            }
        }
    },
    data() {
        return {
            newValue: {},
            beforeAfter: 'after',
            afterElementId: this.guid(),
            beforeElementId: this.guid(),
        }
    },
    props: {
        value: {
            type: Object,
            default: () => {
                return { };
            }
        },
        showBeforeAfter: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        }
    }
};
</script>

<style>

</style>